import { SyncOutlined } from '@ant-design/icons';
import styled from '@emotion/styled';
import { useTranslate } from '@tolgee/react';
import { QRCodeSVG } from 'qrcode.react';
import { useState } from 'react';

const QRCodeWrapper = styled.div`
  position: relative;
  font-size: 0;
`;

export const Refresh = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  font-size: 14px;
  color: #fff;
  background: rgba(0, 0, 0, 0.9);
  cursor: pointer;
  > span {
    font-size: 18px;
  }
`;

const Pay = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 34px;
  padding: 0 28px;
  font-size: 16px;
  font-weight: 500;
  color: var(--fett-text-primary);
  background: var(--fett-surface-warning-bg);
  border-radius: 17px;
`;

export interface CompatQrPayProps {
  payType: Pay.PayType;
  qrCode: string;
  expired: boolean;
  onRefresh: () => Promise<any>;
}

const appOfpayType = {
  airwallex: 'airwallex',
  alipay: '支付宝',
  wxpay: '微信',
  pingpong: 'PingPong',
  lianlian: 'LianLian',
  stripe: 'Stripe',
  asaas: 'Asaas',
} as const;

function CompatQrPay(props: CompatQrPayProps) {
  const { qrCode, expired, onRefresh, payType } = props;

  const { t } = useTranslate();

  const [loading, setLoading] = useState(false);

  return (
    <>
      <QRCodeWrapper>
        <QRCodeSVG value={qrCode} size={160} />
        {expired && (
          <Refresh
            onClick={() => {
              if (!loading) {
                setLoading(true);

                onRefresh().finally(() => {
                  setLoading(false);
                });
              }
            }}
          >
            <SyncOutlined spin={loading} />
            {t('market.重新加载')}
          </Refresh>
        )}
      </QRCodeWrapper>
      <Pay>{t('translation.app扫码支付', { app: t(`translation.${appOfpayType[payType]}`) })}</Pay>
    </>
  );
}

export default CompatQrPay;
